<template>
  <div class="source-lists">
    <div class="widget-12-search">
      <div class="col-md-12 p-l-0 p-r-0">
        <div class="row">
          <div class="m-t-5 m-b-5 col-md-11">
            <h5 class="m-b-0">
              {{ title }}
            </h5>
            <p class="small hint-text">
              {{ subTitle }}
            </p>
          </div>
          <div v-if="collapse" class="p-t-15 col-md-1">
            <i v-if="collapseDefault === 'none'" class="bi bi-chevron-right clickable hoverable" style="cursor: pointer"
              @click="showCardContent" />
            <i v-else class="bi bi-chevron-down clickable hoverable" style="cursor: pointer" @click="showCardContent" />
          </div>
        </div>
      </div>
      <div class="clearfix" />
    </div>
    <div class="company-stat-boxes" :id="param_name + '-lists'" :style="'display: ' + collapseDefault">
      <div v-for="(source, index) in lists" :key="index" :data-index="index"
        class="company-stat-box active p-l-5 p-r-5 p-t-10 p-b-10 b-b b-grey hoverable clickable"
        @click="setFilter($event, index)" :class="[
          {
            'filter-active filter-default': index === 0,
            'source-disable': source.disable === true,
          },
        ]" :id="source.id">
        <div class="pull-left">
          <p class="company-name pull-left text-uppercase bold no-margin" style="
              display: flex;
              justify-content: center;
              align-items: center;
              height: 20px;
              width: 100%;
            ">
            <span :class="!source.disable
              ? source.icon + ' icon-' + source.code
              : source.icon
              " class="mr-2" />
            <span style="
                vertical-align: middle !important;
                display: inline-block;
                line-height: normal;
                text-transform: capitalize;
                font-size: 14px;
              ">
              {{ source.name }}
            </span>
          </p>
        </div>
        <div class="pull-right">
          <p class="bold no-margin inline thousand-separator">
            {{ thousand_separator(source.count) }}
            <span class="fs-10" v-if="source.dalam_kurung">
              ({{ source.dalam_kurung }})
            </span>
          </p>
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import general_plugin from "@/plugins/generalPlugins.js";
export default {
  name: "filter_source_hoax",
  props: {
    param_name: String,
    title: {
      type: String,
      description: "List Title",
    },
    subTitle: String,
    lists: Array,
    collapse: String,
    collapseDefault: String,
  },
  data() {
    return {
      filter_active: [],
    };
  },
  methods: {
    thousand_separator: function (str) {
      return general_plugin.thousandSeparator(str);
    },
    showCardContent: function (event) {
      var card_header = $(event.target).closest(".widget-12-search");
      var isVisible = card_header.next().css("display");
      if (isVisible == "none") {
        card_header.next().slideDown();
        $(event.target).removeClass("bi bi-chevron-right");
        $(event.target).addClass("bi bi-chevron-down");
      } else {
        card_header.next().slideUp();
        $(event.target).removeClass("bi bi-chevron-down");
        $(event.target).addClass("bi bi-chevron-right");
      }
    },
    setFilter: function (event, index) {
      if (!this.lists[index].disable) {
        let value = this.lists[index].id;
        var div_container = $(event.target).closest(".company-stat-box");

        if (div_container.hasClass("filter-default")) {
          div_container.parent().children().removeClass("filter-active");
          div_container.addClass("filter-active");

          this.deleteParam();
        } else if (div_container.hasClass("filter-active")) {
          this.deleteFilter(value);
          if (this.filter_active.length > 0) {
            let q_value = btoa(this.assembleQuery());
            this.updateUrlQuery(this.param_name, q_value);
          } else {
            this.deleteParam();
          }
          div_container.removeClass("filter-active");
        } else {
          if (this.filter_active.length + 1 == this.lists.length - 1) {
            div_container.parent().children().removeClass("filter-active");
            $("filter-default").addClass("filter-active");
          } else {
            div_container
              .parent()
              .children()
              .first()
              .removeClass("filter-active");
            div_container.addClass("filter-active");
          }

          if (!this.filter_active.includes(value)) {
            this.filter_active.push(value);
            if (this.filter_active.length == this.lists.length - 1) {
              this.deleteParam();
            } else {
              let q_value = btoa(this.assembleQuery());
              this.updateUrlQuery(this.param_name, q_value);
            }
          }
        }
        this.$emit("sourceFilterChange");
      }
    },
    assembleQuery: function () {
      let query = this.filter_active.join(",");
      return query.toLowerCase();
    },
    deleteFilter: function (filter) {
      for (var i = 0; i < this.filter_active.length; i++) {
        if (this.filter_active[i] == filter) {
          delete this.filter_active.splice(i, 1);
        }
      }
    },
    deleteParam: function () {
      let queries = this.$route.query;
      delete queries[this.param_name];
      let self = this;
      let current_path = this.$route.path;
      this.$router
        .replace(current_path)
        .then(self.$router.replace({ query: queries }));
      this.filter_active = [];

      $("#" + this.param_name + "-lists")
        .children(".filter-default")
        .addClass("filter-active");
    },
    updateUrlQuery: function (key, value) {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries[key] = value;
      queries.page = 1;
      this.$router.replace({ query: queries });
    },
    initFitler: function () {
      if (this.lists != null) {
        let available_filter = this.$route.query[this.param_name];
        let some_child = this.lists[0].id;
        if (typeof available_filter != "undefined") {
          available_filter = atob(available_filter);
          this.filter_active = available_filter.split(",");
          if (this.filter_active.length == this.lists.length - 1) {
            $("#" + some_child)
              .parent()
              .children()
              .removeClass("filter-active");
            $("#" + some_child)
              .closest(".filter-default")
              .addClass("filter-active");
          } else {
            this.filter_active.forEach(function (id) {
              $("#" + id).addClass("filter-active");
            });
            $("#" + some_child)
              .closest(".filter-default")
              .removeClass("filter-active");
          }
        } else {
          $("#" + some_child)
            .parent()
            .children()
            .removeClass("filter-active");
          $("#" + some_child)
            .closest(".filter-default")
            .addClass("filter-active");
        }
      }
    },
  },
  watch: {
    $route() {
      this.initFitler();
    },
  },
  mounted: function () {
    this.initFitler();
  },
  beforeDestroy: function () {
    this.filter_active = [];
  },
};
</script>

<style scoped>
.fa,
.fab {
  font-size: 25px;
  margin-right: 5px;
  width: 35px;
}

.filter-style {
  cursor: pointer;
}

.filter-style:hover {
  background: #f8f9fa !important;
}

.filter-active {
  background: #d3eeff !important;
  color: #000;
}

.filter-active:hover {
  background: #fffde1 !important;
}

.source-disable {
  color: darkgrey;
  cursor: default;
}

@import "/assets/plugins/bootstrap-social/bootstrap-social.css";
</style>
